import React, { useState, useEffect, FC, useCallback } from "react";
import Content from "../../layout/content/Content";
import { Card, Row, Col, Button, Spinner, DropdownItem } from "reactstrap";
import {
  TableColumnsType,
  Table,
  Progress,
  Select,
  Input,
  Flex,
  Spin,
  Empty,
  Tooltip,
  Drawer,
  Modal,
  Form,
  Popover,
  Timeline,
  Divider,
} from "antd";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  TooltipComponent,
} from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import { SearchOutlined, InfoCircleOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import { useLocation, useNavigate, useParams } from "react-router";
import statusMapper from "./StatusMapper";
import dispatchApis from "../../api/dispatch/dispatch";
import DispatchAside from "./paymentsNav";
import paymentApis from "../../api/payments/payments";
import { formatCurrency, formatCurrency2 } from "../../utils/Utils";
import usersApis from "../../api/master/users";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import SignatureModal from "../purchase-orders/SignatureModal";
import ImageUploadCropper from "../components/ImageUploadCropper";
import dayjs from "dayjs";
const { Option } = Select;
interface WidgetData {
  title: string;
  count: number;
  progress: number;
  color: string;
}

const PendingPaymentApprovals: FC = () => {
  const location = useLocation();
  const id = location?.state?.id;
  console.log("id------", id);

  const { data: currentUser }: any = useSelector(
    (state: RootState) => state.currentUser
  );

  const [form] = Form.useForm();


  const [disableAccept, setDisableAccept] = useState<boolean>(false);
  const [disableReject, setDisableReject] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const [viewDrawer, setViewDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState<any>(null);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [currentUserId, setCurrentUserId] = useState<any>(null);
  const [approverIds, setApproverIds] = useState<any>([]);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [refreshToggle, setRefreshToggle] = useState(false);

  const [isStrictMode, setIsStrictMode] = useState<boolean>(false);
  const [siteOptions, setSiteOptions] = useState<any>([]);

  // Signature states
  const [signature, setSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });
  const [showSignatureModel, setShowSignatureModel] = useState(false);
  const [isModalApproveVisible, setIsModalApproveVisible] = useState(false);
  const [isModalRejectedVisible, setIsModalRejectedVisible] = useState(false);
  const [showActionModelVisible, setShowActionModelVisible] = useState(false);
  const [activeSignatureContext, setActiveSignatureContext] = useState<
    "APPROVE" | "REJECT" | null
  >(null);
  const [approveRecord, setApproveRecord] = useState<any>(null);
  const [rejectRecord, setRejectRecord] = useState<any>(null);
  const [pendingRejectReason, setPendingRejectReason] = useState<string>("");

  // Store drawer state before closing
  const [pendingCloseDrawer, setPendingCloseDrawer] = useState(false);
  const [pendingAction, setPendingAction] = useState<"APPROVE" | "REJECT" | null>(null);

  useEffect(() => {
    if (currentUser) {
      setCurrentUserId(currentUser.id);
      // Fetch site options from current user's site accessibility
      if (currentUser?.siteAccessibility) {
        const _siteOptions = currentUser.siteAccessibility.map((item: any) => ({
          label: item.siteName,
          value: item.siteID,
        }));
        setSiteOptions(_siteOptions);
      }
    }
  }, [currentUser]);

  useEffect(() => {
    if (showRejectModal == false) {
      setDisableReject(false);
    }
  }, [showRejectModal]);

  useEffect(() => {
    if (id) {
      setViewDrawer(true);
      fetchPaymentDetails(id);
    }
  }, [id]);

  // Effect to handle pending drawer close and show modal
  useEffect(() => {
    if (pendingCloseDrawer && !viewDrawer) {
      // Drawer is now closed, show the appropriate modal
      if (pendingAction === "APPROVE") {
        setActiveSignatureContext("APPROVE");
        setIsModalApproveVisible(true);
      } else if (pendingAction === "REJECT") {
        setActiveSignatureContext("REJECT");
        setIsModalRejectedVisible(true);
      }

      // Reset pending states
      setPendingCloseDrawer(false);
      setPendingAction(null);
    }
  }, [pendingCloseDrawer, viewDrawer, pendingAction]);

  const parseLevelNum = (level: any) => {
    if (!level && level !== 0) return NaN;
    const str = String(level).toLowerCase();

    // Handle various level formats: level1, Level2, L1, L2, etc.
    if (str.includes('level')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    } else if (str.startsWith('l')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    }
    return NaN;
  };

  const hasUserAlreadyApproved = drawerData?.paymentApprovals?.some(
    (a: any) =>
      a.userId === currentUserId &&
      a.status?.toUpperCase() === "APPROVED"
  );

  const canUserApproveReject = useCallback(() => {
    // 1. Admin can Approve/Reject anytime - Buttons are always ENABLED
    if (currentUser?.genericRole?.toLowerCase() === "admin") {
      return true;
    }

    const approvals = drawerData?.paymentApprovals || [];

    // Find current user's approval entry
    const userApproval = approvals.find(
      (approval: any) => approval.userId === currentUserId
    );

    if (!userApproval || userApproval.status?.toLowerCase() !== "pending") {
      return false;
    }

    const userLevelNum = parseLevelNum(userApproval.level ?? currentUser?.approvalLevel);

    // 2. Strict = 0 (Flexible mode)
    // Anyone in the approval list can approve at any time
    if (isStrictMode === false) {
      // In flexible mode, just check if user is in the approval list and pending
      return true;
    }

    // 3. Strict = 1 (Sequential mode)
    // Must follow the order. Level 2 cannot see buttons until Level 1 is "Approved"
    if (isStrictMode === true) {
      // Get all pending approvals sorted by level
      const pendingApprovals = approvals
        .filter((approval: any) => approval.status?.toLowerCase() === "pending")
        .sort((a: any, b: any) => {
          const aNum = parseLevelNum(a.level);
          const bNum = parseLevelNum(b.level);
          if (isNaN(aNum) || isNaN(bNum)) return 0;
          return aNum - bNum;
        });

      // If there are no pending approvals, user can't approve
      if (pendingApprovals.length === 0) return false;

      // Get the first pending approval (lowest level)
      const firstPending = pendingApprovals[0];
      const firstPendingLevelNum = parseLevelNum(firstPending.level);

      // Check if user is the first pending approver
      return userApproval.userId === firstPending.userId &&
        userLevelNum === firstPendingLevelNum;
    }

    return false;
  }, [currentUser, currentUserId, drawerData?.paymentApprovals, isStrictMode]);

  const getPendingStatusMessage = () => {
    const approvals = drawerData?.paymentApprovals || [];
    const pendingApprovals = approvals
      .filter((approval: any) => approval.status?.toLowerCase() === "pending")
      .sort((a: any, b: any) => {
        const aNum = parseLevelNum(a.level);
        const bNum = parseLevelNum(b.level);
        if (isNaN(aNum) || isNaN(bNum)) return 0;
        return aNum - bNum;
      });

    if (pendingApprovals?.length > 0) {
      if (!isStrictMode) {
        // Flexible mode - any approver can approve
        const approverNames = pendingApprovals.map((approval: any) => approval.userName).join(", ");
        return `Status is pending. Any of these approvers can approve: ${approverNames}`;
      } else {
        // Strict mode - must follow sequence
        const nextApprover = pendingApprovals[0];
        const lvl = parseLevelNum(nextApprover.level);
        const levelText = !isNaN(lvl) ? `Level ${lvl}` : nextApprover.roleName || "";
        return `Status is pending. Waiting for ${nextApprover.userName} (${levelText}) to approve first.`;
      }
    }

    return "Status is pending by other approvers";
  };

  const columns: any = [
    {
      title: "#",
      key: "#",
      width: 50,
      fixed: "left",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Payment #",
      dataIndex: "paymentId",
      key: "PaymentId",
      width: 200,
      fixed: "left",
      render: (text: any) => (
        <div className="align-left">
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: any) => <span>{FormatDate(date)}</span>,
      width: 170,
    },
    {
      title: "Supplier",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`supplierName-tooltip-${index}`}>
              {text?.length > 20 ? `${text?.substring(0, 25)}... ` : text}
            </span>
            {text?.length > 20 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`supplierName-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Received Amount",
      dataIndex: "payableAmount",
      key: "payableAmount",
      width: 140,
      render: (text: any, record: any) => {
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {formatCurrency(Number(text), "INR")}
              {/* <Tooltip title={formatCurrency(Number(text), "INR")}>
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip> */}
            </span>
          </div>
        );
      },
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
    },
    {
      title: "Status",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      width: 220,
      fixed: "right",
      render: (status: any) => {
        const _status = statusMapper[status]?.buyer;
        return (
          <div className="justify-start align-center">
            <h6
              className={`tb-status ms-1`}
              style={{
                color: `${_status?.color}`,
                fontSize: "14px",
              }}
            >
              {_status?.icon} {_status?.title || status}
            </h6>
          </div>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 70,
      render: (text: any, record: any) => (
        <>
          <Button
            size="sm"
            color=""
            onClick={() => {
              setViewDrawer(true);
              fetchPaymentDetails(record?.paymentNumber);
            }}
          >
            <Icon name="focus" />
          </Button>
        </>
      ),
    },
  ];

  const fetchPaymentDetails = async (paymentNumber: any) => {
    try {
      const res = await paymentApis.fetchPayment(paymentNumber);
      const { data, status, message } = res;
      if (status) {
        const isStrict = data?.isStrictApproval === true || data?.isStrictApproval === 1;;
        setIsStrictMode(isStrict);

        // Process approvals
        if (data?.paymentApprovals) {
          const processedApprovals = data.paymentApprovals.map((approval: any) => ({
            ...approval,
            level: approval.level?.toLowerCase() || approval.level,
            status: approval.status?.toLowerCase() || approval.status
          }));
          data.paymentApprovals = processedApprovals;

          // Filter pending approvals
          let ids = processedApprovals
            ?.filter((item: any) => item?.status?.toLowerCase() !== "approved")
            ?.map((item: any) => item?.userId);
          setApproverIds(ids);
        }

        setDrawerData(data);
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) { }
  };

  const drawerColumns: any = [
    {
      title: "#",
      key: "#",
      width: 50,
      fixed: "left",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Invoice #",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      width: 120,
      fixed: "left",
      render: (text: any) => (
        <div className="align-left">
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: any) => <span>{FormatDate(date)}</span>,
      width: 170,
    },
    {
      title: "Supplier",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 200,
    },
    {
      title: "Payable Amount",
      dataIndex: "payableAmount",
      key: "payableAmount",
      width: 140,
      render: (text: any, record: any) => {
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {formatCurrency(Number(text), "INR")}
              {/* <Tooltip title={formatCurrency(Number(text), "INR")}>
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip> */}
            </span>
          </div>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
  ];

  const dataURLToFile = (dataUrl: string, fileName: string): File => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };

  const handleApprove = async (files: File[] = []) => {
    try {
      setDisableAccept(true);
      const res = await paymentApis.approvePayment(drawerData?.paymentNumber, files);
      const { status, message } = res;
      if (status) {
        Swal.fire("Success", message, "success");
        setRefreshToggle(!refreshToggle);
        setViewDrawer(false);
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {
      console.error("Error approving payment:", error);
      Swal.fire("Error", "Failed to approve payment", "error");
    } finally {
      setDisableAccept(false);
      setSignature({ isActive: false, label: "Authorised Signatory", image: null });
    }
  };

  const handleReject = async (reason: string, files: File[] = []) => {
    try {
      setDisableReject(true);
      const res = await paymentApis.disapprovePayment(
        drawerData?.paymentNumber,
        reason,
        files
      );
      const { status, message } = res;
      if (status) {
        Swal.fire("Success", message, "success");
        setRefreshToggle(!refreshToggle);
        setViewDrawer(false);
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {
      console.error("Error rejecting payment:", error);
      Swal.fire("Error", "Failed to reject payment", "error");
    } finally {
      setDisableReject(false);
      setSignature({ isActive: false, label: "Authorised Signatory", image: null });
      setPendingRejectReason("");
    }
  };

  const openApproveConfirmSwal = () => {
    if (!signature.image) {
      Swal.fire({
        icon: "info",
        title: "Signature Required",
        text: "Please add your signature before approving.",
      });
      return;
    }

    setIsModalApproveVisible(false);

    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "No, keep it",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const file = dataURLToFile(signature.image as string, "signature.png");
        await handleApprove([file]);
      } else {
        setIsModalApproveVisible(true);
      }
    });
  };

  const openRejectConfirmSwal = async () => {
    if (!pendingRejectReason || !pendingRejectReason.trim()) {
      Swal.fire({
        icon: "info",
        title: "Reason Required",
        text: "Please provide a rejection reason before submitting.",
      });
      return;
    }

    if (!signature.image) {
      Swal.fire({
        icon: "info",
        title: "Signature Required",
        text: "Please add your signature before rejecting.",
      });
      return;
    }

    setIsModalRejectedVisible(false);

    Swal.fire({
      title: "Confirm Rejection?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const file = dataURLToFile(signature.image as string, "signature.png");
        await handleReject(pendingRejectReason, [file]);
      } else {
        setIsModalRejectedVisible(true);
      }
    });
  };

  const handleCancel = () => {
    setShowActionModelVisible(false);
    setIsModalRejectedVisible(false);
    form.resetFields();
  };

  const handleApproveClick = () => {
    setPendingAction("APPROVE");
    setPendingCloseDrawer(true);
    setViewDrawer(false);
  };

  const handleRejectClick = () => {
    setPendingAction("REJECT");
    setPendingCloseDrawer(true);
    setViewDrawer(false);
  };

  return (
    <>
      <TransactionFlowDefaultTemplate
        moduleKey="pending-payment-approvals"
        title="Pending Payment Approvals"
        columns={columns}
        sideNavigation={
          <div
            className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${sm ? "content-active" : ""
              }`}
          >
            <DispatchAside updateSm={setSm} sm={sm} />
          </div>
        }
        refresh={refreshToggle}
        selectFilters={[
          {
            title: "Site",
            placeholder: "Select Site",
            options: siteOptions,
            selectionMode: "multiple",
          },
        ]}
        extra={{
          tableScrollX: 1100,
          dateRange: true,
        }}
      />
      <Drawer
        title={
          <div className="d-flex justify-content-between align-items-center">
            <strong>Invoice Payables</strong>
            <div style={{ textAlign: "right" }}>
              {drawerData?.status?.toLowerCase() === "pending" &&
                !hasUserAlreadyApproved &&
                (
                  <>
                    {canUserApproveReject() ? (
                      <>
                        {disableAccept ? (
                          <Button color="primary" type="button" className="m-3 mt-0 mb-0">
                            <Spinner size="sm" color="light" />
                          </Button>
                        ) : (
                          <Button
                            onClick={handleApproveClick}
                            color="primary"
                            className="m-3 mt-0 mb-0"
                          >
                            Approve
                          </Button>
                        )}

                        {disableReject ? (
                          <Button color="light" type="button" className="m-3 mt-0 mb-0">
                            <Spinner size="sm" color="light" />
                          </Button>
                        ) : (
                          <Button
                            onClick={handleRejectClick}
                            color="light"
                            className="m-3 mt-0 mb-0"
                          >
                            Reject
                          </Button>
                        )}
                      </>
                    ) : (
                      <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                        <Button
                          size="sm"
                          color="secondary"
                          className="mx-1"
                          disabled
                          style={{ cursor: "not-allowed", opacity: 0.6 }}
                        >
                          <Icon name="check" /> Approve
                        </Button>

                        <Button
                          size="sm"
                          color="secondary"
                          className="mx-1"
                          disabled
                          style={{ cursor: "not-allowed", opacity: 0.6 }}
                        >
                          <Icon name="cross" /> Reject
                        </Button>

                        <Popover
                          content={
                            <div style={{ padding: "8px", maxWidth: "300px" }}>
                              <p style={{ margin: 0 }}>{getPendingStatusMessage()}</p>
                            </div>
                          }
                          title="Approval Status"
                          trigger="hover"
                        >
                          <InfoCircleOutlined
                            style={{
                              fontSize: "20px",
                              cursor: "pointer"
                            }}
                          />
                        </Popover>
                      </div>
                    )}
                  </>
                )}
            </div>
          </div>
        }
        placement="right"
        onClose={() => setViewDrawer(false)}
        open={viewDrawer}
        width="85vw"
        style={{
          position: "absolute",
          zIndex: 1100,
        }}
        styles={{ body: { paddingBottom: 80 } }}
      >
        {drawerData ? (
          <>
            <div className="d-flex justify-content-between p-3 pb-0 pt-0">
              <div>
                <strong>Remark</strong>
                <p>{drawerData?.remarks}</p>
              </div>
              <div>
                <div className="w-100">
                  <div className="d-flex justify-content-between">
                    <div className="justify-end">
                      <strong>Payable Amount Total &nbsp; &nbsp; </strong>
                    </div>
                    <strong className="fw-bold">
                      {formatCurrency(
                        Number(drawerData?.payableAmount || 0),
                        drawerData?.currencyCode || "INR"
                      )}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive poTable">
              <div
                style={{
                  width: screenSize - 300 + "px",
                  margin: "0px auto 15px auto",
                }}
              >
                <Table
                  className="customTable"
                  columns={drawerColumns}
                  dataSource={drawerData?.paymentLines}
                  scroll={{ x: 1000 }}
                  bordered
                  size="middle"
                  pagination={false}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <Flex align="center" gap="middle" className="pageLoader">
              <Spin size="large" className="m-auto" />
            </Flex>
          </>
        )}


        {drawerData?.paymentApprovals && drawerData?.paymentApprovals.length > 0 && (
          <>
            <Divider />
            <h6>Approval History</h6>
            <Timeline>
              {drawerData?.paymentApprovals?.map(
                (approval: any, index: any) => {
                  // Determine color based on status
                  let color = "blue";
                  if (approval.status?.toLowerCase() === "rejected") {
                    color = "red";
                  } else if (approval.status?.toLowerCase() === "approved") {
                    color = "green";
                  } else if (approval.status?.toLowerCase() === "pending") {
                    color = "gray";
                  }

                  // Format approval date if available
                  const approvalDate = approval.approvalDate
                    ? dayjs(approval.approvalDate).format("DD/MM/YYYY HH:mm")
                    : "Pending";

                  // Get action text based on status
                  let actionText = "";
                  let actionBy = "";

                  if (approval.status?.toLowerCase() === "approved") {
                    actionText = "Approved";
                    actionBy = approval.userName || "Unknown";
                  } else if (approval.status?.toLowerCase() === "rejected") {
                    actionText = "Rejected";
                    actionBy = approval.userName || "Unknown";
                  } else if (approval.status?.toLowerCase() === "pending") {
                    actionText = "Pending";
                    actionBy = approval.userName || "Awaiting";
                  }

                  return (
                    <Timeline.Item
                      key={index}
                      color={color}
                    >
                      <div>
                        <strong>{actionText}</strong> by {actionBy}
                        <div className="text-muted small">
                          {approvalDate} | {approval.roleName || approval.roleId}
                        </div>
                        {approval.status?.toLowerCase() === "pending" && (
                          <div className="mt-1 p-2 bg-light rounded">
                            <small>Waiting for approval</small>
                          </div>
                        )}
                      </div>
                    </Timeline.Item>
                  );
                }
              )}
            </Timeline>
          </>
        )}
      </Drawer >

      <Modal
        title="Approve Payment"
        visible={isModalApproveVisible}
        onOk={() => {
          if (!signature.image) {
            Swal.fire({
              icon: "info",
              title: "Signature Required",
              text: "Please add your signature before approving.",
            });
            return;
          }
          openApproveConfirmSwal();
        }}

        onCancel={() => {
          setIsModalApproveVisible(false);
          setSignature({ isActive: false, label: "Authorised Signatory", image: null });
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>

            {signature.image && (
              <button
                type="button"
                onClick={() =>
                  setSignature({
                    isActive: true,
                    label: "Authorised Signatory",
                    image: null,
                  })
                }
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
              </button>
            )}
          </div>

          {signature.image ? (
            <>
              <div
                className="border mb-3 d-flex justify-content-center align-items-center"
                style={{
                  padding: 16,
                  borderRadius: 8,
                  background: "#fff",
                }}
              >
                <img
                  src={signature.image}
                  alt="Signed"
                  style={{ maxWidth: 220, maxHeight: 120, objectFit: "contain" }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  onClick={() =>
                    setSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                >
                  Reset
                </Button>
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: 220,
                border: "2px dashed #dee2e6",
                borderRadius: 8,
                backgroundColor: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <ImageUploadCropper
                  onOpenCrop={() => setIsModalApproveVisible(false)}
                  onCloseCrop={() => setIsModalApproveVisible(true)}
                  onSave={(data: string) => {
                    setSignature((prev: any) => ({ ...prev, image: data }));
                  }}
                >
                  <Button color="primary" size="sm" outline style={{ minWidth: 140 }} onClick={() => setActiveSignatureContext("APPROVE")}>
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  style={{ minWidth: 140 }}
                  onClick={() => {
                    setIsModalApproveVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal >

      <Modal
        title="Reject Payment"
        visible={isModalRejectedVisible}
        onOk={openRejectConfirmSwal}
        onCancel={() => {
          handleCancel();
          setSignature({ isActive: false, label: "Authorised Signatory", image: null });
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <Form form={form} layout="vertical" name="rejectForm">
          <Form.Item
            name="reason"
            label="Reason for Rejection"
            rules={[{ required: true, message: "Please input your reason!" }]}
          >
            <Input.TextArea
              rows={3}
              placeholder="Type your reason here..."
              onChange={(e) => setPendingRejectReason(e.target.value)} />
          </Form.Item>

          <div className="mt-4">
            <strong style={{ fontSize: "16px" }}>Signature</strong>
          </div>

          {signature.image && (
            <a
              style={{ fontSize: 14, cursor: "pointer" }}
              onClick={() =>
                setSignature({ isActive: true, label: "Authorised Signatory", image: null })
              }
            >
            </a>
          )}


          {signature.image ? (
            <>
              <div className="signatueImgWrapper border mb-3 p-3 text-center">
                <img
                  src={signature.image}
                  alt="Signed"
                  style={{ width: "180px", height: "auto" }}
                />
              </div>
              <div className="d-flex justify-content-end mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  className="me-2"
                  onClick={() =>
                    setSignature({ isActive: true, label: "Authorised Signatory", image: null })
                  }
                >
                  Reset
                </Button>
              </div>

            </>
          ) : (
            <div
              style={{
                minHeight: "200px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
                border: "2px dashed #dee2e6",
                borderRadius: "8px",
                backgroundColor: "#f8f9fa"
              }}
            >
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
                <ImageUploadCropper
                  onOpenCrop={() => setIsModalRejectedVisible(false)}
                  onCloseCrop={() => setIsModalRejectedVisible(true)}
                  onSave={(data: string) => {
                    setSignature((prev: any) => ({ ...prev, image: data }));
                  }}
                >
                  <Button color="primary" size="sm" outline onClick={() => setActiveSignatureContext("REJECT")}>
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  onClick={() => {
                    setIsModalRejectedVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </Form>
      </Modal>


      {
        showSignatureModel && (
          <SignatureModal
            modal={showSignatureModel}
            toggle={() => {
              setShowSignatureModel(false);
              if (activeSignatureContext === "APPROVE") {
                setIsModalApproveVisible(true);
              } else if (activeSignatureContext === "REJECT") {
                setIsModalRejectedVisible(true);
              }
            }}
            onSave={(data: string) => {
              setSignature((prev: any) => ({ ...prev, image: data }));
              setShowSignatureModel(false);

              if (activeSignatureContext === "APPROVE") {
                setIsModalApproveVisible(true);
              } else if (activeSignatureContext === "REJECT") {
                setIsModalRejectedVisible(true);
              }
            }}
          />
        )
      }
    </>
  );
};

export default PendingPaymentApprovals;
